<template>
	<div>
		<!-- 스탬프 설명 -->
		<TheAsStampDescription />

		<!-- 스탬프 현황 -->
		<AsStampStatus />
	</div>
</template>

<script>
import '@/assets/css/as-stamp.css';

import TheAsStampDescription from './TheAsStampDescription';
import AsStampStatus from './AsStampStatus';

export default {
	components: {
		TheAsStampDescription,
		AsStampStatus,
	},
};
</script>
